import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('hero-carousel')) {
    class HeroCarousel extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.elSlides = null;
            this.elNav = null;
            this.enabled = false;
        }

        connectedCallback() {
            this.#init();
        }

        async #init() {
            this.elSlides = this.querySelectorAll('.swiper-slide');
            this.elNav = this.querySelectorAll('[data-navigation]');
            this.enabled = this.elSlides.length > 1;

            if (!this.enabled) {
                this.elNav.forEach(el => el.style.display = 'none');
                this.setAttribute('data-swiper-ready', '');
                this.classList.add('hero-carousel--swiper-init', 'hero-carousel--slides-visible');
                return;
            }

            this.autoplay = this.getAttribute('autoplay') === 'true';
            this.autoplayDelay = Number(this.getAttribute('autoplay-delay') || 5) * 1000;

            const Swiper = await loadSwiper({ waitForLoad: false });

            // Swiper loop + centeredSlides requires all slides visible during init
            this.setAttribute('data-swiper-ready', '');

            this.swiper = new Swiper(this, {
                enabled: this.enabled,
                loop: this.enabled,
                centeredSlides: true,
                centerInsufficientSlides: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 750,
                autoplay: this.autoplay ? {
                    delay: this.autoplayDelay,
                    disableOnInteraction: true,
                } : false,
                navigation: {
                    nextEl: this.querySelector('[data-navigation="next"]'),
                    prevEl: this.querySelector('[data-navigation="prev"]'),
                },
                on: {
                    init: (swiper) => {
                        if (swiper.params.loop) {
                            swiper.slideToLoop(0, 0);
                        } else {
                            swiper.slideTo(0, 0);
                        }

                        this.classList.add('hero-carousel--swiper-init');

                        requestAnimationFrame(() => {
                            this.classList.add('hero-carousel--slides-visible');
                        });

                        if (this.autoplay && swiper.autoplay) {
                            swiper.autoplay.stop();
                            this.#queueAutoplay(swiper);
                        }
                    },
                },
            });
        }

        #queueAutoplay(swiper) {
            if (!this.autoplay || !swiper?.autoplay) return;

            swiper.autoplay.stop();

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

            const startAutoplay = () => {
                if (!this.swiper?.autoplay) return;

                const firstImage = this.querySelector('.swiper-slide:not(.swiper-slide-duplicate) img');

                const start = () => {
                    this.swiper?.autoplay?.start();
                };

                if (firstImage && !firstImage.complete) {
                    firstImage.addEventListener('load', start, { once: true });
                    firstImage.addEventListener('error', start, { once: true });
                    return;
                }

                start();
            };

            if (document.readyState === 'complete') {
                startAutoplay();
                return;
            }

            window.addEventListener('load', startAutoplay, { once: true });
        }
    }
    customElements.define('hero-carousel', HeroCarousel);
}
